<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose">
      <LesperiodDoc v-if="dialogVisible" :lesperiodId="lesperiodId" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
import LesperiodDoc from '../lesperiodDoc'
export default {
  name: 'LesDocUp',
  components: { LesperiodDoc },
  data () {
    return {
      dialogVisible: false,
      lesperiodId: null,
      title: '查看课件'
    }
  },
  methods: {
    init(lesperiodId, name) {
      this.lesperiodId = lesperiodId
      this.title = `查看课件【${name}】`
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.lesDocUp {

}
</style>
